import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ASSET_TYPE from "../../constants/publishingAssetTypes";
import SaveMovieToDiskTabContent from "./SaveMovieToDiskTabContent";
import SaveImageToDiskTabContent from "./SaveImageToDiskTabContent";

class SaveToDiskTab extends React.PureComponent {
  render() {
    return this.props.assetType === ASSET_TYPE.movie.toLowerCase() ? (
      <SaveMovieToDiskTabContent onSave={this.props.onSave} />
    ) : (
      <SaveImageToDiskTabContent onDownload={this.props.onDownload} />
    );
  }
}

SaveToDiskTab.propTypes = {
  assetType: PropTypes.string.isRequired,
  onDownload: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  assetType: state.publish.assetType
});

export default connect(mapStateToProps)(SaveToDiskTab);



// WEBPACK FOOTER //
// ./app/components/RenderMediaDialog/SaveToDiskTabContent.js